import React, { useEffect, useState } from 'react';
import axios from '../../public Func/axiosAuth';

import { Button } from '../../components/ui';
import './SettingsPage.css';

function SettingsPage() {
  const [systemCutPercentage, setSystemCutPercentage] = useState('');
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  useEffect(() => {
    axios.get(process.env.REACT_APP_BACKEND_URL + '/admin/settings')
      .then(res => {
        if (res.data?.systemCutPercentage !== undefined) {
          setSystemCutPercentage(String(res.data.systemCutPercentage));
        }
      })
      .catch(err => {
        setMessage({ type: 'error', text: err.response?.data?.message || 'Failed to load settings.' });
      })
      .finally(() => setLoading(false));
  }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    const pct = parseFloat(systemCutPercentage);
    if (isNaN(pct) || pct < 0 || pct > 100) {
      setMessage({ type: 'error', text: 'Percentage must be between 0 and 100.' });
      return;
    }
    setSubmitting(true);
    setMessage({ type: '', text: '' });
    try {
      const res = await axios.put(process.env.REACT_APP_BACKEND_URL + '/admin/settings', { systemCutPercentage: pct });
      setSystemCutPercentage(String(res.data?.systemCutPercentage ?? pct));
      setMessage({ type: 'success', text: 'Settings saved successfully.' });
    } catch (err) {
      setMessage({ type: 'error', text: err.response?.data?.message || 'Failed to save settings.' });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="settings-page">
      <div className="settings-header">
        <h1 className="page-title">Settings</h1>
        <p className="page-subtitle">Configure platform-wide parameters.</p>
      </div>

      <div className="settings-card">
        <h2>Financial Settings</h2>
        <p className="section-desc">
          Set the percentage of each appointment's price that the system retains.
          The remainder is the doctor's cut.
        </p>

        {loading ? (
          <p style={{ color: 'var(--text-secondary)' }}>Loading...</p>
        ) : (
          <form onSubmit={handleSave}>
            {message.text && (
              <div className={`settings-message ${message.type}`}>{message.text}</div>
            )}
            <div className="settings-field">
              <label htmlFor="systemCutPercentage">System Cut Percentage (%)</label>
              <input
                id="systemCutPercentage"
                type="number"
                min="0"
                max="100"
                step="0.01"
                value={systemCutPercentage}
                onChange={e => setSystemCutPercentage(e.target.value)}
                placeholder="e.g. 10"
                required
              />
              <span className="field-hint">
                Example: entering 15 means the system keeps 15% of each appointment price and the doctor receives 85%.
              </span>
            </div>
            <Button type="submit" variant="primary" disabled={submitting}>
              {submitting ? 'Saving...' : 'Save Settings'}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}

export default SettingsPage;
